import { render, staticRenderFns } from "./rightMenuList.vue?vue&type=template&id=51c714fa&scoped=true"
import script from "./rightMenuList.vue?vue&type=script&lang=ts"
export * from "./rightMenuList.vue?vue&type=script&lang=ts"
import style0 from "./rightMenuList.vue?vue&type=style&index=0&id=51c714fa&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c714fa",
  null
  
)

export default component.exports